<template>
  <div
    class="absolute top-[calc(100%+8px)] z-20 bg-white rounded-lg w-[238px] max-h-[222px] overflow-auto shadow-lg custom-scroll flex flex-col border border-grayh-100"
    :class="direction"
  >
    <div v-if="searchable" class="p-1 shrink-0">
      <div class="relative flex flex-row items-center gap-1 h-[40px]">
        <span
          class="material-symbols-outlined text-gray-500 absolute top-50 ltr:left-2 rtl:right-2"
        >
          search
        </span>
        <input
          ref="searchbar"
          :value="search"
          type="text"
          class="search-input ltr:pl-[40px] rtl:pr-[40px]"
          autofocus="true"
          :placeholder="placeholder"
          @input="$emit('update:search', $event.target.value)"
        />
      </div>
    </div>
    <slot name="header" :filtered-items="filteredItems" />
    <div
      v-for="item in filteredItems"
      :key="item.id"
      class="text-gray-600 gap-2 dropdown-item"
      :class="{
        active: selectedItems.includes(item[selectedKey]),
        disabled: item.disabled,
        ltr: !isRTLView,
        rtl: isRTLView,
      }"
      @click.prevent="$emit('select', item)"
    >
      <slot name="item" :item="item" />
    </div>
    <div
      v-if="noResult"
      class="flex items-center justify-center pb-4 px-2.5 text-sm text-gray-400 dark:text-slate-200 flex-1"
    >
      {{ noResultText }}
    </div>
    <slot name="footer" />
  </div>
</template>

<script>
import { picoSearch } from '@scmmishra/pico-search';
import rtlMixin from 'shared/mixins/rtlMixin';

export default {
  name: 'DropdownPanel',
  mixins: [rtlMixin],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
    selectedKey: {
      type: String,
      default: 'id',
    },
    searchKeys: {
      type: Array,
      default: () => ['name'],
    },
    searchable: {
      type: Boolean,
      default: false,
    },
    search: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    noResultText: {
      type: String,
      default: '',
    },
    direction: {
      type: String,
      default: () => 'right-0',
    },
  },
  computed: {
    filteredItems() {
      if (!this.search) return this.items;

      return picoSearch(this.items, this.search, this.searchKeys, {
        threshold: 0.9,
      });
    },
    noResult() {
      return this.searchable && this.filteredItems.length === 0;
    },
  },
  mounted() {
    if (this.searchable) this.focusInput();
  },
  methods: {
    focusInput() {
      this.$refs.searchbar.focus();
    },
  },
};
</script>

<style lang="scss" scoped>
.search-input {
  @apply mb-0 text-sm border-[#D1D5DB];

  &:focus,
  &:hover {
    border-color: #D1D5DB;
  }

  &::placeholder {
    color: #9CA3AF;
    font-size: 14px;
  }
}

.dropdown-item {
  @apply px-3 py-[7px] flex flex-row items-center cursor-pointer relative select-none;

  &:hover {
    @apply bg-[#F0FDF4] hover:text-[#1F845A];

    .material-symbols-outlined {
      @apply text-[#1F845A];
    }
  }

  &.active {
    @apply bg-[#F0FDF4];
    &:after {
      content: '';
      background-image: url(/images/checked.svg);
      width: 12px;
      height: 8px;
      background-origin: content-box;
      background-position-x: center;
      background-repeat: no-repeat;
      background-size: 12px 8px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      padding: 0;
    }
    &.ltr {
      &:after {
        right: 12px;
      }
    }
    &.rtl {
      &:after {
        left: 12px;
      }
    }
  }

  &.disabled {
    @apply text-gray-400 hover:text-gray-400 hover:bg-transparent focus:bg-transparent focus:text-gray-400 cursor-not-allowed;
  }
}
</style>
